import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { Icons, Text } from '../../index';
import { useDraggableInPortal } from './useDraggableInPortal';
const CellContainer = styled.div `
  padding: 0.5rem;
  display: flex;
  align-items: center;
  ${({ theme }) => `background-color: ${theme.colors.SNOW_100}`}
  > svg {
    min-width: 1rem;
  }
  :hover {
    ${({ theme }) => `background-color: ${theme.colors.PRIMARY_200};`}
  }
  ${({ isDragging, theme }) => isDragging ? `background-color: ${theme.colors.PRIMARY_200};` : ''}
`;
const DragIconContent = styled.div `
  display: flex;
  margin-right: 0.5rem;
`;
const CrossIconContent = styled.div `
  display: flex;
  cursor: pointer;
`;
const DraggableContent = styled.div `
  margin-bottom: 0.5rem;
`;
const InfoContent = styled.div `
  display: flex;
  flex: 1;
`;
const ListCell = ({ id, index, label, lang, onDelete, fixed, showIndex, }) => {
    const renderDraggable = useDraggableInPortal();
    return (React.createElement(DraggableContent, null,
        React.createElement(Draggable, { key: id, draggableId: id, index: index }, renderDraggable((provided, snapshot) => (React.createElement(CellContainer, Object.assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { isDragging: snapshot.isDragging, style: provided.draggableProps.style }),
            React.createElement(DragIconContent, null,
                React.createElement(Icons.Outline.Drag, { size: "SMALL" })),
            React.createElement(InfoContent, null,
                React.createElement(Text, { fontType: "Body", lang: lang }, `${showIndex ? `${index + 1}. ` : ''}${label}`)),
            !fixed && (React.createElement(CrossIconContent, { onClick: () => onDelete && onDelete({ index }) },
                React.createElement(Icons.Outline.Cross, { size: "SMALL", color: "INK_400" })))))))));
};
export default ListCell;
//# sourceMappingURL=ListCell.js.map